import React, { FC } from 'react';
import Router from './Router';

const App: FC = () => {
  return (
    <React.StrictMode>
      <Router />
    </React.StrictMode>
  );
};

export default App;
